

import axios from 'axios';

const API_KEY = 'b17207d21346daa45477c7c254d38e88'; // Replace with your actual TMDb API key
const BASE_URL = 'https://api.themoviedb.org/3';

export const fetchMovies = async (endpoint, page = 1) => {
    const response = await axios.get(`${BASE_URL}${endpoint}`, {
      params: {
        api_key: API_KEY,
        language: 'en-US',
        page: page
      }
    });
    return response.data;
  };// Add this function to your existing api.js
export const fetchMovieDetails = async (movieId) => {
  try {
    const response = await axios.get(`${BASE_URL}/movie/${movieId}`, {
      params: {
        api_key: API_KEY,
        language: 'en-US'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching movie details:', error);
    throw error;
  }
};